import publicApi from "@/services/publicApi";

export type RegistrateDraftResponse = {
  id: string;
  name: string;
  email: string;
  phone: string;
  document: string;
  status: string;
  typeCompany: "PF" | "PJ";
  nickName: string | null;
  useAssociateTax: boolean;
};

class GetRegistrateDraft {
  execute = async (partnerId: string): Promise<RegistrateDraftResponse> => {
    const res = await publicApi().get<RegistrateDraftResponse>(
      `registrate/continue/${partnerId}`,
    );
    return res.data;
  };
}

export { GetRegistrateDraft };
